import snakecaseKeys from 'snakecase-keys'
import { serialize } from 'object-to-formdata'
import axiosIns from '@/plugins/axios'

export default {
  getUsers() {
    return axiosIns.get('/v2/employee/user_management/users')
  },

  createUser(params) {
    const userData = {
      name: params.name,
      role: params.role,
      userSystemFlaggingsAttributes: params.userSystemFlaggingsAttributes,
      userCustomFieldValuesAttributes: params.userCustomFieldValuesAttributes,
      userAggregationTemplateId: params.userAggregationTemplateId,
      aggregationRole: params.aggregationRole,
    }
    const formData = serialize(snakecaseKeys({ user: userData }))

    if (params.profileImage instanceof File) {
      formData.append('user[profile_image]', params.profileImage)
    }

    return axiosIns.post('/v2/employee/user_management/users', formData)
  },

  updateUser(params) {
    const userData = {
      name: params.name,
      userSystemFlaggingsAttributes: params.userSystemFlaggingsAttributes,
      userCustomFieldValuesAttributes: params.userCustomFieldValuesAttributes,
      userAggregationTemplateId: params.userAggregationTemplateId,
      aggregationRole: params.aggregationRole,
      aggregationIds: params.aggregations,
    }

    let formData = serialize(snakecaseKeys({ user: userData }, { exclude: ['_destroy'] }))

    // aggregation_idsを正しいインデックス付きで手動追加
    if (userData.aggregationIds && Array.isArray(userData.aggregationIds)) {
      // 既存のaggregation_idsを削除
      const entries = Array.from(formData.entries())
      const newFormData = new FormData()

      // 既存のエントリを再追加（aggregation_ids以外）
      entries.forEach(([key, value]) => {
        if (!key.startsWith('user[aggregation_ids]')) {
          newFormData.append(key, value)
        }
      })
      // aggregation_idsを正しいインデックス付きで追加
      userData.aggregationIds.forEach((aggregation, index) => {
        if (aggregation.ids && Array.isArray(aggregation.ids)) {
          aggregation.ids.forEach(id => {
            newFormData.append(`user[aggregation_ids][${index}][ids][]`, id)
          })
        }
        if (aggregation.type) {
          newFormData.append(`user[aggregation_ids][${index}][type]`, aggregation.type)
        }
      })
      // 新しいFormDataを代入
      formData = newFormData
    }

    // プロフィール画像がFileオブジェクトの場合はFormDataを使用
    if (params.profileImage instanceof File) {
      formData.append('user[profile_image]', params.profileImage)
    }

    return axiosIns.put(`/v2/employee/user_management/users/${params.id}`, formData)
  },

  deleteUser(id) {
    return axiosIns.delete(`/v2/employee/user_management/users/${id}`)
  },

  updatePassword(id, password) {
    return axiosIns.put(`/v2/employee/user_management/users/${id}/update_password`, { password })
  },
}
